import { WIZARD_AUDIENCE } from './constants';
import { textareaStyle, categoryBtnStyle } from './wizardStyles';
import { haptic } from '../../utils/haptic';

export interface Step2Data {
  problem: string;
  what_done: string;
  audience: string[];
}

export function WizardStep2({
  data,
  onPatch,
}: {
  data: Step2Data;
  onPatch: (patch: Partial<Step2Data>) => void;
}) {
  const toggleAudience = (label: string) => {
    haptic.select();
    const next = data.audience.includes(label)
      ? data.audience.filter((a) => a !== label)
      : [...data.audience, label];
    onPatch({ audience: next });
  };

  return (
    <div style={{ paddingBottom: 100 }}>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
          Какую проблему решает? <span style={{ color: 'var(--accent2, #c084fc)' }}>*</span>
        </label>
        <textarea
          rows={3}
          value={data.problem}
          onChange={(e) => onPatch({ problem: e.target.value })}
          placeholder="Опишите проблему..."
          style={textareaStyle}
          onFocus={(e) => (e.target.style.borderColor = 'rgba(180,100,255,0.35)')}
          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.07)')}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 6 }}>
          Как решает? <span style={{ color: 'var(--accent2, #c084fc)' }}>*</span>
        </label>
        <textarea
          rows={3}
          value={data.what_done}
          onChange={(e) => onPatch({ what_done: e.target.value })}
          placeholder="Опишите решение..."
          style={textareaStyle}
          onFocus={(e) => (e.target.style.borderColor = 'rgba(180,100,255,0.35)')}
          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.07)')}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>
          Аудитория (можно несколько) <span style={{ color: 'var(--accent2, #c084fc)' }}>*</span>
        </label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {WIZARD_AUDIENCE.map((label) => (
            <button
              key={label}
              type="button"
              style={categoryBtnStyle(data.audience.includes(label))}
              onClick={() => toggleAudience(label)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
